import { ElementType } from "../../dom-tools/ElementType";
import { LinkedGraphicalElement } from "../graphical/LinkedGraphicalElement";
import { UIComponent } from "./UIComponent";

export class ScrollContainer extends UIComponent
{
  static readonly elementType = new ElementType( "ui--scroll--container" );
  
  readonly content = new LinkedGraphicalElement( this );

  constructor()
  {
    super();
    this._setElement( ScrollContainer.elementType.create() );

    this.element.style.overflow = "hidden";
  }

}